"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9273],{

/***/ 49273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ui_Menu; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/@styled-icons/material-outlined/KeyboardArrowLeft/KeyboardArrowLeft.esm.js
var KeyboardArrowLeft_esm = __webpack_require__(90756);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(32692);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./node_modules/styled-media-query/dist/styled-media-query.es.js
var styled_media_query_es = __webpack_require__(60605);
;// CONCATENATED MODULE: ./src/components/ui/Menu/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    max-width: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: calc(",
        " / 2);\n    padding-right: calc(",
        " / 2);\n    background: transparent;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    padding: 1rem 0;\n    position: relative;\n    z-index: ",
        ";\n    background-color: ",
        ";\n    border-bottom: 2px solid ",
        ";\n    justify-content: end;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-grow: 1;\n    justify-content: flex-end;\n    align-items: center;\n    #notification-btn {\n      all: unset;\n      position: relative;\n      margin: 0 10px;\n      cursor: pointer;\n      &.ativo {\n        &::before {\n          content: attr(data-notification-count);\n          position: absolute;\n          width: 1.5rem;\n          height: 1.5rem;\n          display: grid;\n          place-items: center;\n          color: white;\n          font-weight: 600;\n          font-size: 12px;\n          border-radius: 999px;\n          background-color: ",
        ";\n          top: 0;\n          right: 0;\n          z-index: 1;\n        }\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    /* margin-left: ",
        "; */\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-family: ",
        ";\n    &:hover {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          display:none;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n    &:hover {\n      color: ",
        ";\n    }\n    &::after {\n      content: '';\n      position: absolute;\n      display: block;\n      height: 4px;\n      width: 100%;\n      top: 4.7rem;\n      left: 0;\n      background-color: ",
        ";\n      ",
        "\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0.3rem 1.2rem 0;\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    font-family: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n    margin: 0.3rem ",
        " 0;\n    text-decoration: none;\n    text-align: center;\n    transition: color, ",
        ";\n\n    ",
        "\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}


var ContainerMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91852b63-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.grid.container, theme.grid.gutter, theme.grid.gutter);
});
var Wrapper = styled_components_browser_esm/* default.menu.withConfig */.ZP.menu.withConfig({
    componentId: "sc-91852b63-1"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.layers.menu, theme.colors.white, theme.colors.border);
});
var MenuGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91852b63-2"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), theme.colors.orange);
});
var MenuNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-91852b63-3"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6(), theme.spacings.small);
});
var linkModifiers = {
    default: function(theme) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), theme.colors.gray, theme.font.family, theme.colors.gray);
    },
    active: function(theme) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), theme.colors.black, theme.colors.black, theme.colors.borderMenu, styled_media_query_es/* default.lessThan */.ZP.lessThan("large")(_templateObject9()));
    }
};
var MenuLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-91852b63-4"
})(_templateObject13(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject12(), theme.font.family, theme.colors.gray, theme.font.sizes.medium, theme.spacings.small, theme.transition.default, !isActive && linkModifiers.default(theme), isActive && linkModifiers.active(theme), styled_media_query_es/* default.between */.ZP.between("large", "huge")(_templateObject11()));
});
var BotaoVoltar = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-91852b63-5"
})(_templateObject14());

// EXTERNAL MODULE: ./src/components/ui/MediaMatch/index.tsx
var MediaMatch = __webpack_require__(14247);
;// CONCATENATED MODULE: ./src/components/ui/Dropdown/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    color: ",
        ";\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding-right: 2.4rem;\n    z-index: ",
        ";\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: auto;\n    min-width: 200px;\n    display: flex;\n    flex-direction: column;\n    background: ",
        ";\n    color: ",
        ";\n    margin-top: ",
        ";\n    position: absolute;\n    right: 0;\n    z-index: ",
        ";\n    border-radius: 10px;\n    font-family: ",
        ";\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n    padding: 1.4rem 0;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100vw;\n    height: 100vh;\n    background: transparent;\n    position: fixed;\n    top: 0;\n    left: 0;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateY(0);\n    visibility: visible;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 0;\n    pointer-events: none;\n    transform: translateY(-2rem);\n    visibility: hidden;\n  "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    width: max-content;\n\n    ",
        ", ",
        " {\n      transition: transform 0.2s ease-in, opacity ",
        ";\n\n      ",
        "\n      ",
        "\n    }\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb19de85-0"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject(), theme.colors.white, theme.layers.alwaysOnTop);
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb19de85-1"
})(styles_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject2(), theme.colors.white, theme.colors.black, theme.spacings.xxsmall, theme.layers.alwaysOnTop, theme.font.family);
});
var ContentBoxMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb19de85-2"
})(styles_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject4());
});
var wrapperModifiers = {
    open: function() {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject6());
    },
    close: function() {
        return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject7());
    }
};
var styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb19de85-3"
})(styles_templateObject9(), function(param) {
    var theme = param.theme, isOpen = param.isOpen;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject8(), Content, ContentBoxMenu, theme.transition.default, isOpen && wrapperModifiers.open(), !isOpen && wrapperModifiers.close());
});

;// CONCATENATED MODULE: ./src/components/ui/Dropdown/index.tsx



var Dropdown = function(param) {
    var title = param.title, children = param.children;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Wrapper, {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                "aria-hidden": !isOpen,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBoxMenu, {
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                "aria-hidden": !isOpen
            })
        ]
    });
};
/* harmony default export */ var ui_Dropdown = (Dropdown);

;// CONCATENATED MODULE: ./src/components/ui/UserIcon/styles.ts

function UserIcon_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    svg{\n      width:40px;\n    }\n    "
    ]);
    UserIcon_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserIcon_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    svg {\n      width: 40px;\n    }\n    ",
        "\n  "
    ]);
    UserIcon_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserIcon_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserIcon_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var UserIcon_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b46ecd84-0"
})(UserIcon_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(UserIcon_styles_templateObject1(), theme.colors.primary, styled_media_query_es/* default.lessThan */.ZP.lessThan("large")(UserIcon_styles_templateObject(), theme.colors.white));
});

;// CONCATENATED MODULE: ./src/components/ui/UserIcon/index.tsx


var UserIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "56",
            height: "56",
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M38.5 21C38.5 23.7848 37.3938 26.4555 35.4246 28.4246C33.4555 30.3938 30.7848 31.5 28 31.5C25.2152 31.5 22.5445 30.3938 20.5754 28.4246C18.6062 26.4555 17.5 23.7848 17.5 21C17.5 18.2152 18.6062 15.5445 20.5754 13.5754C22.5445 11.6062 25.2152 10.5 28 10.5C30.7848 10.5 33.4555 11.6062 35.4246 13.5754C37.3938 15.5445 38.5 18.2152 38.5 21Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M0 28C0 20.5739 2.94999 13.452 8.20101 8.20101C13.452 2.94999 20.5739 0 28 0C35.4261 0 42.548 2.94999 47.799 8.20101C53.05 13.452 56 20.5739 56 28C56 35.4261 53.05 42.548 47.799 47.799C42.548 53.05 35.4261 56 28 56C20.5739 56 13.452 53.05 8.20101 47.799C2.94999 42.548 0 35.4261 0 28ZM28 3.5C23.3862 3.50025 18.8663 4.80327 14.9604 7.2591C11.0545 9.71492 7.92149 13.2237 5.92187 17.3817C3.92226 21.5396 3.13735 26.1777 3.65749 30.762C4.17764 35.3464 5.98169 39.6907 8.862 43.295C11.347 39.291 16.8175 35 28 35C39.1825 35 44.6495 39.2875 47.138 43.295C50.0183 39.6907 51.8224 35.3464 52.3425 30.762C52.8626 26.1777 52.0777 21.5396 50.0781 17.3817C48.0785 13.2237 44.9455 9.71492 41.0396 7.2591C37.1337 4.80327 32.6138 3.50025 28 3.5Z",
                    fill: "currentColor"
                })
            ]
        })
    });
};
/* harmony default export */ var ui_UserIcon = (UserIcon);

// EXTERNAL MODULE: ./src/hooks/useAuth.tsx
var useAuth = __webpack_require__(83276);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(48081);
// EXTERNAL MODULE: ./src/core/const/routes.ts
var routes = __webpack_require__(92819);
;// CONCATENATED MODULE: ./src/components/UserDropdown/styles.ts

function UserDropdown_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 300px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "
    ]);
    UserDropdown_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    width: 20rem;\n  "
    ]);
    UserDropdown_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserDropdown_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 ",
        ";\n  "
    ]);
    UserDropdown_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserDropdown_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    margin: 0 0.5rem;\n    > p {\n      font-family: ",
        ";\n      font-size: ",
        ";\n      color: ",
        ";\n      margin: 0;\n      ",
        ";\n\n      > strong {\n        font-family: ",
        ";\n        font-weight: ",
        ";\n        font-size: 2.4rem;\n        color: ",
        ";\n        margin: 0;\n        margin-left: 2px;\n      }\n    }\n  "
    ]);
    UserDropdown_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserDropdown_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    background: ",
        ";\n    color: ",
        ";\n    padding: ",
        " 0;\n    margin: 0 ",
        ";\n    transition: background, color, ",
        ";\n    font-family: ",
        ";\n    font-size: ",
        ";\n    &:hover {\n      color: ",
        ";\n    }\n  "
    ]);
    UserDropdown_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function UserDropdown_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    UserDropdown_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var userModifiers = {
    reduzir: function() {
        return (0,styled_components_browser_esm/* css */.iv)(UserDropdown_styles_templateObject());
    }
};
var Nav = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-e9d1cf49-0"
})(UserDropdown_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(UserDropdown_styles_templateObject1());
});
var Username = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e9d1cf49-1"
})(UserDropdown_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(UserDropdown_styles_templateObject3(), theme.spacings.xxsmall);
});
var User = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9d1cf49-2"
})(UserDropdown_styles_templateObject6(), function(param) {
    var theme = param.theme, reduzirNomeUsuario = param.reduzirNomeUsuario;
    return (0,styled_components_browser_esm/* css */.iv)(UserDropdown_styles_templateObject5(), theme.font.family, theme.font.sizes.medium, theme.colors.black, reduzirNomeUsuario && userModifiers.reduzir(), theme.font.family, theme.font.bold, theme.colors.primary);
});
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e9d1cf49-3"
})(UserDropdown_styles_templateObject8(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(UserDropdown_styles_templateObject7(), theme.colors.white, theme.colors.black, theme.spacings.xxsmall, theme.spacings.small, theme.transition.default, theme.font.family, theme.font.sizes.small, theme.colors.grayStage);
});

// EXTERNAL MODULE: ./src/config.js + 1 modules
var config = __webpack_require__(40727);
// EXTERNAL MODULE: ./src/utils/analyticsevents.ts
var analyticsevents = __webpack_require__(7391);
;// CONCATENATED MODULE: ./src/components/UserDropdown/index.tsx











var UserDropdown = function(param) {
    var reduzirNomeUsuario = param.reduzirNomeUsuario;
    var ref = (0,useAuth/* default */.Z)(), usuario = ref.usuario, signOut = ref.signOut;
    var primeiroNome = (usuario === null || usuario === void 0 ? void 0 : usuario.nome) && helpers/* default.obterPrimeiroNome */.Z.obterPrimeiroNome(usuario === null || usuario === void 0 ? void 0 : usuario.nome);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_Dropdown, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                greaterThan: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(User, {
                            reduzirNomeUsuario: reduzirNomeUsuario,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Ol\xe1, ",
                                        "",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: primeiroNome
                                        }),
                                        " "
                                    ]
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_UserIcon, {})
                    ]
                })
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: routes/* routes.dashboard */._.dashboard,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        onClick: function() {
                            return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                click_text: "Meus ambientes"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Meus ambientes"
                        })
                    })
                }),
                (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) != config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: routes/* routes.dadosPessoais */._.dadosPessoais,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        onClick: function() {
                            return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                click_text: "Dados pessoais"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Dados pessoais"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: routes/* routes.redefinirSenhaPainel */._.redefinirSenhaPainel,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        onClick: function() {
                            return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                click_text: "Alterar senha"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Alterar senha"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "https://br.pinterest.com/arquitetodebolso/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: function() {
                            return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                click_text: "Inspire-se"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Inspire-se"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "https://api.whatsapp.com/send?phone=5511935033604",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: function() {
                            return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                click_text: "Ajuda"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Ajuda"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    onClick: function() {
                        analyticsevents/* gtmHeaderMenuUsuario */.$I({
                            click_text: "Sair"
                        });
                        signOut();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Sair"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_UserDropdown = (UserDropdown);

;// CONCATENATED MODULE: ./src/components/MenuStep/styles.ts

function MenuStep_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .vcv-timeline {\n      position: relative;\n      display: flex;\n      align-items: center;\n      max-width: 1000px;\n      margin: 0 auto;\n      padding: 0;\n      list-style-type: none;\n      color: ",
        ";\n    }\n\n    .vcv-timeline-item {\n      min-width: 200px;\n      display: flex;\n      align-items: center;\n\n      padding: 0;\n      position: relative;\n      &::before,\n      &::after {\n        content: '';\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        height: 2px;\n        background: ",
        ";\n        width: 100%;\n        margin: 0 10px;\n      }\n\n      &:last-of-type {\n        flex: 0 0 120px;\n        &::after {\n          display: none;\n        }\n      }\n\n      &.vcv-step-done {\n        &::before {\n          content: '';\n          border-color: ",
        ";\n          background: ",
        " no-repeat center;\n          background-size: 40%;\n        }\n\n        &::after {\n          background: ",
        ";\n        }\n      }\n      span {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: ",
        ";\n\n        height: 45px;\n        width: 45px;\n        margin: 0 10px 0 0;\n        border-radius: 50%;\n        border: 2px solid ",
        ";\n        color: ",
        ";\n        z-index: 2;\n        font-size: ",
        ";\n\n        &.ativo {\n          border: 2px solid ",
        ";\n          color: ",
        ";\n        }\n      }\n      p {\n        font-size: 10px;\n        color: ",
        ";\n        margin-bottom: 3rem;\n        &.ativo {\n          color: ",
        ";\n        }\n      }\n    }\n  "
    ]);
    MenuStep_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MenuStep_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuStep_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var MenuStep_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7f5654b-0"
})(MenuStep_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(MenuStep_styles_templateObject(), theme.colors.containerGray, theme.colors.containerGray, theme.colors.primary, theme.colors.white, theme.colors.primary, theme.colors.white, theme.colors.containerGray, theme.colors.containerGray, theme.font.sizes.medium, theme.colors.primary, theme.colors.primary, theme.colors.containerGray, theme.colors.primary);
});

;// CONCATENATED MODULE: ./src/components/MenuStep/index.tsx





var MenuStep = function(param) {
    var avancar = param.avancar, material = param.material, plantaTecnica = param.plantaTecnica, cloneConsultoria = param.cloneConsultoria;
    var teste = function teste() {
        var li = document.querySelectorAll(".vcv-timeline-item");
        var span = document.querySelectorAll(".bol-Number");
        var title = document.querySelectorAll(".pTitle");
        if ((usuario === null || usuario === void 0 ? void 0 : usuario.perfil) != config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO) {
            switch(avancar){
                case 1:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    break;
                case 2:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    break;
                case 3:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    break;
                case 4:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    break;
                case 5:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    break;
                case 6:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    break;
                case 7:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    break;
                case 8:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    li[4].classList.add("vcv-step-done");
                    span[4].classList.add("ativo");
                    title[4].classList.add("ativo");
                    break;
                case 9:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    li[4].classList.add("vcv-step-done");
                    span[4].classList.add("ativo");
                    title[4].classList.add("ativo");
                    break;
                case 10:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    li[4].classList.add("vcv-step-done");
                    span[4].classList.add("ativo");
                    title[4].classList.add("ativo");
                    break;
            }
        } else {
            switch(avancar){
                case 1:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    break;
                case 2:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    break;
                case 3:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    break;
                case 4:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    break;
                case 5:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    break;
                case 6:
                    li[0].classList.add("vcv-step-done");
                    span[0].classList.add("ativo");
                    title[0].classList.add("ativo");
                    li[1].classList.add("vcv-step-done");
                    span[1].classList.add("ativo");
                    title[1].classList.add("ativo");
                    li[2].classList.add("vcv-step-done");
                    span[2].classList.add("ativo");
                    title[2].classList.add("ativo");
                    li[3].classList.add("vcv-step-done");
                    span[3].classList.add("ativo");
                    title[3].classList.add("ativo");
                    break;
            }
        }
    };
    var usuario = (0,useAuth/* default */.Z)().usuario;
    (0,react.useEffect)(function() {
        teste();
    }, [
        avancar
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuStep_styles_Wrapper, {
        children: (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) != config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: material ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: "vcv-timeline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "vcv-timeline-item ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "bol-Number",
                                    children: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pTitle",
                                    children: "Plantas e Uploads"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "vcv-timeline-item ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "bol-Number",
                                    children: "2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pTitle",
                                    children: "Pr\xe9-agendamento"
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: plantaTecnica ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "vcv-timeline",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                            className: "vcv-timeline-item ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "bol-Number",
                                    children: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "pTitle",
                                    children: "Plantas T\xe9cnica"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: cloneConsultoria ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "vcv-timeline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Selecione o ambiente"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Pr\xe9-agendamento"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "vcv-timeline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Plantas e Uploads"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Pr\xe9-agendamento"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Ambientes e refer\xeancias"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Cores Texturas e ilumina\xe7\xe3o"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    className: "vcv-timeline-item ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bol-Number",
                                            children: "5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "pTitle",
                                            children: "Detalhes do ambiente"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "vcv-timeline",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "vcv-timeline-item ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bol-Number",
                                children: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pTitle",
                                children: "Cadastro Cliente"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "vcv-timeline-item ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bol-Number",
                                children: "2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pTitle",
                                children: "Cadastro Parceiro"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "vcv-timeline-item ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bol-Number",
                                children: "3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pTitle",
                                children: "Configura Ambiente"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "vcv-timeline-item ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "bol-Number",
                                children: "4"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pTitle",
                                children: "Plantas e Uploads"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_MenuStep = (MenuStep);

// EXTERNAL MODULE: ./node_modules/react-joyride/dist/index.mjs + 11 modules
var dist = __webpack_require__(62201);
;// CONCATENATED MODULE: ./src/components/ui/MenuMobileApp/styles.ts

function MenuMobileApp_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-family: ",
        ";\n    &:hover {\n      color: ",
        ";\n    }\n  "
    ]);
    MenuMobileApp_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    color: ",
        ";\n    font-weight: 700;\n\n    &::before {\n      content: '';\n      position: absolute;\n      display: block;\n      height: 4px;\n      width: 100%;\n      top: -8px;\n      left: 0;\n      background-color: #833d90;\n    }\n  "
    ]);
    MenuMobileApp_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: ",
        ";\n    position: fixed;\n    bottom: 0;\n    background-color: ",
        ";\n    gap: ",
        ";\n    padding: ",
        " ",
        ";\n    border-top: 1px solid ",
        ";\n    z-index: ",
        ";\n  "
    ]);
    MenuMobileApp_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuMobileApp_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    ",
        "\n    ",
        "\n  "
    ]);
    MenuMobileApp_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuMobileApp_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n"
    ]);
    MenuMobileApp_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: 'Gill Sans' !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    margin-top: 0.4rem;\n  "
    ]);
    MenuMobileApp_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function MenuMobileApp_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuMobileApp_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var styles_linkModifiers = {
    default: function(theme) {
        return (0,styled_components_browser_esm/* css */.iv)(MenuMobileApp_styles_templateObject(), theme.colors.gray, theme.font.family, theme.colors.gray);
    },
    active: function(theme) {
        return (0,styled_components_browser_esm/* css */.iv)(MenuMobileApp_styles_templateObject1(), theme.colors.black);
    }
};
var MenuMobileApp_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b78bfaf4-0"
})(MenuMobileApp_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(MenuMobileApp_styles_templateObject2(), theme.heights.footer, theme.colors.white, theme.spacings.small, theme.spacings.xxsmall, theme.spacings.xsmall, theme.colors.containerGray, theme.layers.menu);
});
var IconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b78bfaf4-1"
})(MenuMobileApp_styles_templateObject5(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return (0,styled_components_browser_esm/* css */.iv)(MenuMobileApp_styles_templateObject4(), !isActive && styles_linkModifiers.default(theme), isActive && styles_linkModifiers.active(theme));
});
var IconContent = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b78bfaf4-2"
})(MenuMobileApp_styles_templateObject6());
var IconName = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b78bfaf4-3"
})(MenuMobileApp_styles_templateObject8(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(MenuMobileApp_styles_templateObject7(), theme.font.sizes.small, theme.colors.black);
});

// EXTERNAL MODULE: ./node_modules/@styled-icons/evil/Close/Close.esm.js
var Close_esm = __webpack_require__(22459);
;// CONCATENATED MODULE: ./src/components/ui/MenuFullMobile/styles.ts

function MenuFullMobile_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 300px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  "
    ]);
    MenuFullMobile_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: ",
        ";\n    position: fixed;\n    z-index: 1;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100vh;\n    overflow: hidden;\n    background: ",
        ";\n    transition: opacity 0.3s ease-in-out;\n    opacity: ",
        ";\n    pointer-events: ",
        ";\n    padding: ",
        ";\n  "
    ]);
    MenuFullMobile_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuFullMobile_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"
    ]);
    MenuFullMobile_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 38px;\n    position: absolute;\n    right: 0;\n    color: ",
        ";\n  "
    ]);
    MenuFullMobile_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuFullMobile_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    border-bottom: 0.5px solid #cecece;\n    padding-bottom: ",
        ";\n  "
    ]);
    MenuFullMobile_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuFullMobile_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: ",
        ";\n  "
    ]);
    MenuFullMobile_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function MenuFullMobile_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    MenuFullMobile_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    a {\n      font-family: 'Gill Sans' !important;\n      font-size: ",
        ";\n      text-decoration: none;\n      color: #8d8d8d;\n    }\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    align-items: flex-start;\n\n    p {\n      font-family: 'Gill Sans' !important;\n      font-size: ",
        ";\n      color: ",
        ";\n      margin: 0;\n      ",
        ";\n    }\n\n    strong {\n      font-family: 'Gill Sans' !important;\n      font-weight: ",
        ";\n      font-size: ",
        ";\n      color: ",
        ";\n      margin: 0;\n      margin-left: 2px;\n    }\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ",
        ";\n\n    a,\n    span {\n      font-family: 'Gill Sans' !important;\n      font-size: ",
        ";\n      text-decoration: none;\n      color: #343434;\n    }\n  "
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: auto;\n\n    span {\n      font-family: 'Gill Sans' !important;\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


var styles_userModifiers = {
    reduzir: function() {
        return (0,styled_components_browser_esm/* css */.iv)(MenuFullMobile_styles_templateObject());
    }
};
var MenuFull = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74933913-0"
})(MenuFullMobile_styles_templateObject2(), function(param) {
    var theme = param.theme, isOpen = param.isOpen;
    return (0,styled_components_browser_esm/* css */.iv)(MenuFullMobile_styles_templateObject1(), theme.spacings.large, theme.colors.white, isOpen ? 1 : 0, isOpen ? "all" : "none", theme.spacings.medium);
});
var HeaderMenu = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-74933913-1"
})(MenuFullMobile_styles_templateObject3());
var CloseMenu = (0,styled_components_browser_esm/* default */.ZP)(Close_esm/* Close */.x).withConfig({
    componentId: "sc-74933913-2"
})(MenuFullMobile_styles_templateObject5(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(MenuFullMobile_styles_templateObject4(), theme.colors.newPrimary);
});
var UserMenuContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-74933913-3"
})(MenuFullMobile_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(MenuFullMobile_styles_templateObject6(), theme.spacings.xsmall);
});
var styles_UserIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74933913-4"
})(MenuFullMobile_styles_templateObject9(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(MenuFullMobile_styles_templateObject8(), theme.spacings.xsmall);
});
var UserInfoContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74933913-5"
})(styles_templateObject11(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject10(), theme.font.sizes.small);
});
var UserInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74933913-6"
})(styles_templateObject13(), function(param) {
    var theme = param.theme, reduzirNomeUsuario = param.reduzirNomeUsuario;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject12(), theme.font.sizes.xlarge, theme.colors.black, reduzirNomeUsuario && styles_userModifiers.reduzir(), theme.font.bold, theme.font.sizes.xlarge, theme.colors.primary);
});
var NavContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74933913-7"
})(_templateObject15(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(styles_templateObject14(), theme.spacings.xsmall, theme.font.sizes.medium);
});
var ExitContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74933913-8"
})(_templateObject17(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject16(), theme.font.sizes.xlarge, theme.font.bold, theme.colors.newPrimary);
});

// EXTERNAL MODULE: ./public/img/logo-login.png
var logo_login = __webpack_require__(74062);
;// CONCATENATED MODULE: ./public/img/menu/icon-user-mobile.svg
/* harmony default export */ var icon_user_mobile = ({"src":"/_next/static/media/icon-user-mobile.7b6f0f50.svg","height":40,"width":40});
;// CONCATENATED MODULE: ./src/components/ui/MenuFullMobile/index.tsx











var MenuFullMobile = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, handleClickStartTutorialMobile = param.handleClickStartTutorialMobile, possuiConsultoriaPremium = param.possuiConsultoriaPremium;
    var ref = (0,useAuth/* default */.Z)(), usuario = ref.usuario, signOut = ref.signOut;
    var primeiroNome = (usuario === null || usuario === void 0 ? void 0 : usuario.nome) && helpers/* default.obterPrimeiroNome */.Z.obterPrimeiroNome(usuario === null || usuario === void 0 ? void 0 : usuario.nome);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuFull, {
            "aria-hidden": !isOpen,
            isOpen: isOpen,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMenu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo_login/* default */.Z,
                            width: 80,
                            height: 80,
                            alt: "Logo Arquiteto bolso"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseMenu, {
                            onClick: function() {
                                return setIsOpen(false);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserMenuContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_UserIcon, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: icon_user_mobile,
                                width: 44,
                                height: 44,
                                alt: "Icone usu\xe1rio"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfoContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo, {
                                    reduzirNomeUsuario: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Ol\xe1, ",
                                                ""
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: primeiroNome
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: routes/* routes.dadosPessoais */._.dadosPessoais,
                                    passHref: true,
                                    title: "Editar dados pessoais",
                                    children: "Editar dados pessoais"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavContainer, {
                    className: "gtm-app-header-menu",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* routes.redefinirSenhaPainel */._.redefinirSenhaPainel,
                            title: "Alterar senha",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "passo-mf-alterar-senha",
                                onClick: function() {
                                    return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                        click_text: "Alterar senha"
                                    });
                                },
                                children: "Alterar senha"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routes/* routes.presentes */._.presentes,
                            title: "Presentes",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "passo-mf-presentes",
                                onClick: function() {
                                    return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                        click_text: "Presentes"
                                    });
                                },
                                children: "Presentes"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://br.pinterest.com/arquitetodebolso/",
                            title: "Inspire-se",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                className: "passo-mf-inspirese",
                                onClick: function() {
                                    return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                        click_text: "Inspire-se"
                                    });
                                },
                                children: "Inspire-se"
                            })
                        }),
                        possuiConsultoriaPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://bit.ly/assistente-ab",
                            passHref: true,
                            title: "Assistente Virtual do AB",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                className: "passo-mf-assistenteab",
                                onClick: function() {
                                    return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                        click_text: "Assistente Virtual do AB"
                                    });
                                },
                                children: "Assistente Virtual do AB"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://api.whatsapp.com/send?phone=5511935033604",
                            passHref: true,
                            title: "Contato/Ajuda",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                className: "passo-mf-contato-ajuda",
                                onClick: function() {
                                    return analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                        click_text: "Contato/Ajuda"
                                    });
                                },
                                children: "Contato/Ajuda"
                            })
                        }),
                        (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) == config/* default.PERFIL_CLIENTE */.Z.PERFIL_CLIENTE && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            onClick: function() {
                                analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                    click_text: "Tutorial"
                                });
                                handleClickStartTutorialMobile && handleClickStartTutorialMobile();
                            },
                            children: "Tutorial"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function() {
                            analyticsevents/* gtmHeaderMenuUsuario */.$I({
                                click_text: "Sair"
                            });
                            signOut();
                        },
                        children: "Sair"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ui_MenuFullMobile = (MenuFullMobile);

// EXTERNAL MODULE: ./src/contexts/JoyrideTour/JoyrideTourContext.tsx + 3 modules
var JoyrideTourContext = __webpack_require__(84697);
;// CONCATENATED MODULE: ./src/components/ui/MenuMobileApp/index.tsx











var stepsTutorialMobile = [
    {
        target: ".passo-mf-alterar-senha",
        title: "Para alterar a senha cadastrada em seu perfil",
        content: "Basta informar a nova senha e a atualiza\xe7\xe3o ser\xe1 feita com sucesso.",
        disableBeacon: true
    },
    {
        target: ".passo-mf-presentes",
        title: "Receba e veja consultorias de presentes enviados no seu perfil",
        content: "Caso tenha recebido um presente venha at\xe9 aqui para aceitar o seu presente e come\xe7ar a transformar o seu ambiente!",
        disableBeacon: true
    },
    {
        target: ".passo-mf-inspirese",
        title: "Est\xe1 precisando de refer\xeancias para o seu ambiente?",
        content: "O Arquiteto de Bolso tem mais de 65 mil projetos realizados para te inspirar.",
        disableBeacon: true
    },
    {
        target: ".passo-mf-assistenteab",
        title: "Assistente 24h por intelig\xeancia artificial exclusiva para clientes Premium",
        content: "Tire d\xfavidas sobre reforma e decora\xe7\xe3o com nosso assistente personalizado.",
        disableBeacon: true
    },
    {
        target: ".passo-mf-contato-ajuda",
        title: "Est\xe1 com dificuldades e gostaria de ajuda?",
        content: "Entre em contato com nosso time de Felicidade do Cliente atrav\xe9s do WhatsApp.",
        disableBeacon: true
    },
    {
        target: ".passo-menumob-ambientes",
        title: "Aqui voc\xea encontrar\xe1 as consultorias contratadas",
        content: "Todos os ambientes em um lugar \xfanico, al\xe9m de visualizar etapas de cada consultoria e os passos necess\xe1rios.",
        disableBeacon: true
    },
    {
        target: ".passo-menumob-dna",
        title: "Aqui voc\xea encontrar\xe1 nossa intelig\xeancia artificial gratuita para descobrir o DNA do seu ambiente",
        content: "Imagens geradas especialmente pra voc\xea criadas a partir do seu estilo, tudo de gra\xe7a.",
        disableBeacon: true
    },
    {
        target: ".passo-menumob-cupons",
        title: "Cupons exclusivos de lojas parceiras para voc\xea economizar na sua compra",
        content: "Transforme seu ambiente com AB economizando no design de ambiente at\xe9 a compra dos produtos.",
        disableBeacon: true
    },
    {
        target: ".passo-menumob-duvidas",
        title: "Aqui voc\xea encontrar\xe1 a resposta para as perguntas mais frequentes",
        content: "Nosso time preparou todas as respostas com muito carinho para te auxiliar na jornada da sua transforma\xe7\xe3o.",
        disableBeacon: true
    },
    {
        target: ".passo-consultoria",
        title: "Cada consultoria contratada ter\xe1 um espa\xe7o \xfanico para seu ambiente",
        content: "\xc9 aqui que voc\xea vai enviar as informa\xe7\xf5es do ambiente, confirmar a consultoria e visualizar a entrega do seu arquiteto.",
        disableBeacon: true
    },
    {
        target: ".passo-menu-mobile-rodape",
        title: "Informa\xe7\xf5es e Links \xdateis",
        content: "Aqui voc\xea encontra as informa\xe7\xf5es de contato do nosso time de Felicidade do Cliente e seu hor\xe1rio de atendimento.",
        disableBeacon: true
    }
];
var IconLink = function(param) {
    var href = param.href, src = param.src, alt = param.alt, name = param.name, target = param.target, onClick = param.onClick, isActive = param.isActive, className = param.className;
    var handleClick = function() {
        analyticsevents/* gtmHeaderMenu */.qG({
            click_text: name
        });
        if (onClick) onClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        isActive: isActive,
        onClick: onClick ? handleClick : undefined,
        className: className,
        children: !onClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconContent, {
                target: target,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: src,
                        alt: alt,
                        width: 32,
                        height: 33
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconName, {
                        children: name
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconContent, {
            target: target,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: src,
                    alt: alt,
                    width: 32,
                    height: 33
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconName, {
                    children: name
                })
            ]
        })
    });
};
var MenuMobileApp = function(param) {
    var activeLink = param.activeLink, possuiConsultoriaPremium = param.possuiConsultoriaPremium;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,JoyrideTourContext/* useJoyrideContext */.o)(), setRun = ref1.setRun, setSteps = ref1.setSteps, dataCallback = ref1.dataCallback;
    var handleClickStartTutorialMobile = function() {
        setRun(true);
        var validSteps = stepsTutorialMobile;
        if (!possuiConsultoriaPremium) {
            validSteps = removeStepByTarget(validSteps, ".passo-mf-assistenteab");
        }
        if ((router_default()).pathname !== routes/* routes.minhasConsultorias */._.minhasConsultorias) {
            validSteps = removeStepByTarget(validSteps, ".passo-consultoria");
        }
        setSteps(validSteps);
    };
    var removeStepByTarget = function(steps, targetToRemove) {
        return steps.filter(function(step) {
            return step.target !== targetToRemove;
        });
    };
    var handleJoyrideCallback = function() {
        if (!dataCallback) return;
        var status = dataCallback.status, action = dataCallback.action, step = dataCallback.step;
        var finishedStatuses = [
            dist/* STATUS.FINISHED */.Q_.FINISHED,
            dist/* STATUS.SKIPPED */.Q_.SKIPPED
        ];
        if (finishedStatuses.includes(status)) {
            setRun(false);
        }
        if (step.target === ".passo-menumob-ambientes" && action === "update") {
            setIsOpen(false);
        }
    };
    (0,react.useEffect)(function() {
        if (!dataCallback) return;
        handleJoyrideCallback();
    }, [
        dataCallback
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuMobileApp_styles_Wrapper, {
        className: "gtm-app-header-menu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                href: routes/* routes.minhasConsultorias */._.minhasConsultorias,
                src: "/img/menu/icon-ambientes.svg",
                alt: "Logo",
                name: "Ambientes",
                isActive: activeLink === routes/* routes.minhasConsultorias */._.minhasConsultorias,
                className: "passo-menumob-ambientes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                href: routes/* routes.match */._.match,
                src: "/img/menu/icon-dna.svg",
                alt: "Logo",
                name: "Match",
                isActive: activeLink === routes/* routes.match */._.match,
                className: "passo-menumob-dna"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                href: routes/* routes.cupons */._.cupons,
                src: "/img/menu/icon-cupons.svg",
                alt: "Logo",
                name: "Cupons",
                className: "passo-menumob-cupons"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLink, {
                href: routes/* routes.faq */._.faq,
                src: "/img/menu/icon-duvidas.svg",
                alt: "Logo",
                name: "D\xfavidas",
                isActive: activeLink === routes/* routes.faq */._.faq,
                className: "passo-menumob-duvidas"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconContainer, {
                onClick: function() {
                    return setIsOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/img/menu/icon-menu.svg",
                        alt: "Logo",
                        width: 32,
                        height: 33
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconName, {
                        children: "Mais"
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MenuFullMobile, {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                handleClickStartTutorialMobile: handleClickStartTutorialMobile,
                possuiConsultoriaPremium: possuiConsultoriaPremium
            })
        ]
    });
};
/* harmony default export */ var ui_MenuMobileApp = (MenuMobileApp);

// EXTERNAL MODULE: ./src/components/ui/Button/index.tsx
var Button = __webpack_require__(34636);
;// CONCATENATED MODULE: ./public/img/menu/icon-tutorial.svg
/* harmony default export */ var icon_tutorial = ({"src":"/_next/static/media/icon-tutorial.cb9c67b4.svg","height":14,"width":14});
;// CONCATENATED MODULE: ./src/components/ui/Menu/index.tsx



















var stepsTutorialDesktop = [
    {
        target: ".passo-menudkt-meus-ambientes",
        title: "Aqui voc\xea encontrar\xe1 as consultorias contratadas",
        content: "Todos os ambientes em um lugar \xfanico, al\xe9m de visualizar etapas de cada consultoria e os passos necess\xe1rios.",
        disableBeacon: true
    },
    {
        target: ".passo-menudkt-presentes",
        title: "Receba e veja consultorias de presentes enviados no seu perfil",
        content: "Caso tenha recebido um presente venha at\xe9 aqui para aceitar o seu presente e come\xe7ar a transformar o seu ambiente!",
        disableBeacon: true
    },
    {
        target: ".passo-menudkt-cupons",
        title: "Cupons exclusivos de lojas parceiras para voc\xea economizar na sua compra",
        content: "Transforme seu ambiente com AB economizando no design de ambiente at\xe9 a compra dos produtos.",
        disableBeacon: true
    },
    {
        target: ".passo-menudkt-faq",
        title: "Aqui voc\xea encontrar\xe1 a resposta para as perguntas mais frequentes",
        content: "Nosso time preparou todas as respostas com muito carinho para te auxiliar na jornada da sua transforma\xe7\xe3o.",
        disableBeacon: true
    },
    {
        target: ".passo-menudkt-assistenteab",
        title: "Assistente 24h por intelig\xeancia artificial exclusiva para clientes Premium",
        content: "Tire d\xfavidas sobre reforma e decora\xe7\xe3o com nosso assistente personalizado.",
        disableBeacon: true
    },
    {
        target: ".passo-consultoria",
        title: "Aqui voc\xea encontrar\xe1 as consultorias contratadas",
        content: "Todos os ambientes em um lugar \xfanico, al\xe9m de visualizar etapas de cada consultoria e os passos necess\xe1rios.",
        disableBeacon: true
    },
    {
        target: ".passo-menu-rodape",
        title: "Informa\xe7\xf5es e Links \xdateis",
        content: "Aqui voc\xea encontra as informa\xe7\xf5es de contato do nosso time de Felicidade do Cliente e seu hor\xe1rio de atendimento.",
        disableBeacon: true
    }
];
var Menu = function(param) {
    var activeLink = param.activeLink, plantaTecnica = param.plantaTecnica, cloneConsultoria = param.cloneConsultoria, avancar = param.avancar, setAvancar = param.setAvancar, material = param.material, possuiConsultoriaPremium = param.possuiConsultoriaPremium;
    var verificaUrlIndex = function verificaUrlIndex() {
        var caminho = activeLink === null || activeLink === void 0 ? void 0 : activeLink.split("?");
        if (caminho) setUrlIndex(caminho[0]);
    };
    var usuario = (0,useAuth/* default */.Z)().usuario;
    var ref = (0,react.useState)(""), urlIndex = ref[0], setUrlIndex = ref[1];
    var reduzirNomeUsuario = avancar ? true : false;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,JoyrideTourContext/* useJoyrideContext */.o)(), setRun = ref1.setRun, setSteps = ref1.setSteps;
    var handleClickStartTutorialDesktop = function() {
        setRun(true);
        var validSteps = stepsTutorialDesktop;
        if (!possuiConsultoriaPremium) {
            validSteps = removeStepByTarget(validSteps, ".passo-menudkt-assistenteab");
        }
        if (router.pathname !== routes/* routes.minhasConsultorias */._.minhasConsultorias) {
            validSteps = removeStepByTarget(validSteps, ".passo-consultoria");
        }
        setSteps(validSteps);
    };
    var removeStepByTarget = function(steps, targetToRemove) {
        return steps.filter(function(step) {
            return step.target !== targetToRemove;
        });
    };
    (0,react.useEffect)(function() {
        verificaUrlIndex();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                greaterThan: "large",
                large: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerMenu, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                        children: [
                            avancar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                    greaterThan: "large",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex",
                                        children: [
                                            (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) != config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: avancar > 1 && avancar < 11 && /*#__PURE__*/ (0,jsx_runtime.jsx)(BotaoVoltar, {
                                                    "aria-label": "Bot\xe3o voltar",
                                                    onClick: function() {
                                                        return setAvancar && setAvancar(avancar - 1);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft_esm/* KeyboardArrowLeft */.R, {
                                                        size: 42,
                                                        color: "#7F0BA4"
                                                    })
                                                })
                                            }),
                                            avancar && !plantaTecnica && !cloneConsultoria && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuStep, {
                                                avancar: avancar,
                                                material: material
                                            }),
                                            avancar && plantaTecnica && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuStep, {
                                                avancar: avancar,
                                                plantaTecnica: plantaTecnica
                                            }),
                                            avancar && cloneConsultoria && !plantaTecnica && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuStep, {
                                                avancar: avancar,
                                                cloneConsultoria: cloneConsultoria
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                greaterThan: "large",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuNav, {
                                    className: "gtm-app-header-menu",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* routes.minhasConsultorias */._.minhasConsultorias,
                                            passHref: true,
                                            title: "Meus ambientes",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                className: "passo-menudkt-meus-ambientes",
                                                isActive: activeLink === routes/* routes.minhasConsultorias */._.minhasConsultorias || routes/* routes.consultoriaDetalhes */._.consultoriaDetalhes === urlIndex,
                                                title: "Meus ambientes",
                                                onClick: function() {
                                                    return analyticsevents/* gtmHeaderMenu */.qG({
                                                        click_text: "Meus ambientes"
                                                    });
                                                },
                                                children: "Meus ambientes"
                                            })
                                        }),
                                        (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) != config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* routes.presentes */._.presentes,
                                            passHref: true,
                                            title: "Presentes",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                className: "passo-menudkt-presentes",
                                                isActive: activeLink === routes/* routes.presentes */._.presentes,
                                                title: "Presentes",
                                                onClick: function() {
                                                    return analyticsevents/* gtmHeaderMenu */.qG({
                                                        click_text: "Presentes"
                                                    });
                                                },
                                                children: "Presentes"
                                            })
                                        }),
                                        (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) != config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* routes.cupons */._.cupons,
                                            passHref: true,
                                            title: "cupons",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                className: "passo-menudkt-cupons",
                                                isActive: activeLink === routes/* routes.cupons */._.cupons,
                                                title: "Cupons",
                                                onClick: function() {
                                                    return analyticsevents/* gtmHeaderMenu */.qG({
                                                        click_text: "Cupons"
                                                    });
                                                },
                                                children: "Cupons"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://arquitetodebolso.com.br/perguntas-frequentes/",
                                            passHref: true,
                                            title: "Faq",
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                isActive: activeLink === routes/* routes.faq */._.faq,
                                                className: "passo-menudkt-faq",
                                                onClick: function() {
                                                    return analyticsevents/* gtmHeaderMenu */.qG({
                                                        click_text: "D\xfavidas"
                                                    });
                                                },
                                                children: "D\xfavidas"
                                            })
                                        }),
                                        possuiConsultoriaPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://bit.ly/assistente-ab",
                                            passHref: true,
                                            title: "Assistente Virtual do AB",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "passo-menudkt-assistenteab",
                                                onClick: function() {
                                                    return analyticsevents/* gtmHeaderMenu */.qG({
                                                        click_text: "Assistente Virtual do AB"
                                                    });
                                                },
                                                children: "Assistente Virtual do AB"
                                            })
                                        }),
                                        (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) == config/* default.PERFIL_EXTERNO */.Z.PERFIL_EXTERNO && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://aprenda.arquitetodebolso.com.br/courses?showcase=3",
                                            passHref: true,
                                            title: "Treinamento",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                                target: "_blank",
                                                onClick: function() {
                                                    return analyticsevents/* gtmHeaderMenu */.qG({
                                                        click_text: "Treinamento"
                                                    });
                                                },
                                                children: "Treinamento"
                                            })
                                        }),
                                        (usuario === null || usuario === void 0 ? void 0 : usuario.perfil) == config/* default.PERFIL_CLIENTE */.Z.PERFIL_CLIENTE && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            size: "medium",
                                            buttonAround: true,
                                            colorButton: "#833D90",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: icon_tutorial,
                                                width: 13,
                                                height: 13,
                                                alt: "\xcdcone de tutorial"
                                            }),
                                            style: {
                                                padding: "1rem 1.5rem"
                                            },
                                            onClick: function() {
                                                analyticsevents/* gtmHeaderMenu */.qG({
                                                    click_text: "Tutorial"
                                                });
                                                handleClickStartTutorialDesktop();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    marginLeft: "5px"
                                                },
                                                children: "Tutorial"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuGroup, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                        greaterThan: "large",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserDropdown, {
                                            reduzirNomeUsuario: reduzirNomeUsuario
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                                        lessThan: "large",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_UserIcon, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaMatch/* default */.Z, {
                lessThan: "large",
                large: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MenuMobileApp, {
                    activeLink: activeLink,
                    possuiConsultoriaPremium: possuiConsultoriaPremium
                })
            })
        ]
    });
};
/* harmony default export */ var ui_Menu = (Menu);


/***/ }),

/***/ 7391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ gtmHeaderMenuUsuario; },
/* harmony export */   "Dm": function() { return /* binding */ gtmCuponsGerarCupom; },
/* harmony export */   "Fu": function() { return /* binding */ gtmCuponsVerCupom; },
/* harmony export */   "Fv": function() { return /* binding */ gtmSelectItem; },
/* harmony export */   "HP": function() { return /* binding */ gtmStoriesView; },
/* harmony export */   "Lt": function() { return /* binding */ formatCategoriesToItems; },
/* harmony export */   "VN": function() { return /* binding */ gtmViewItemList; },
/* harmony export */   "WR": function() { return /* binding */ gtmStoriesOpen; },
/* harmony export */   "lK": function() { return /* binding */ gtmStoriesSelectCTA; },
/* harmony export */   "qG": function() { return /* binding */ gtmHeaderMenu; },
/* harmony export */   "rG": function() { return /* binding */ gtmTrackAmbienteSelecionado; },
/* harmony export */   "wn": function() { return /* binding */ formatItemToGA4; },
/* harmony export */   "zI": function() { return /* binding */ gtmAmbienteMenu; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52875);


var pushEventToDataLayer = function(eventName, eventParams) {
    if ( true && window.dataLayer) {
        window.dataLayer.push((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
            event: eventName
        }, eventParams));
    } else {
        console.warn("DataLayer n\xe3o dispon\xedvel");
    }
};
/**
 * Evento disparado quando o usuário clica em uma opção no menu do cabeçalho
 * @param params Parâmetros do evento
 */ var gtmHeaderMenu = function(params) {
    pushEventToDataLayer("app_header_menu", params);
};
/**
 * Evento disparado quando o usuário clica em uma opção no menu do usuário
 * @param params Parâmetros do evento
 */ var gtmHeaderMenuUsuario = function(params) {
    pushEventToDataLayer("app_header_menu_usuario", params);
};
/**
 * Evento disparado quando o usuário seleciona um ambiente
 * @param ambienteId ID do ambiente
 * @param ambienteNome Nome do ambiente
 * @param ambienteCategoria Categoria do ambiente (Diamante, Premium, etc.)
 * @param ambienteStatus Status do ambiente
 */ var gtmTrackAmbienteSelecionado = function(ambienteId, ambienteNome, ambienteCategoria, ambienteStatus) {
    var params = {
        environment_id: ambienteId,
        environment_name: ambienteNome || "Ambiente sem nome",
        environment_category: ambienteCategoria || "Categoria n\xe3o definida",
        environment_status: String(ambienteStatus) || "Status n\xe3o definido"
    };
    pushEventToDataLayer("app_ambientes_seleciona_ambiente", params);
};
/**
 * Evento disparado quando o usuário clica em uma opção no menu de ambiente
 * @param params Parâmetros do evento
 */ var gtmAmbienteMenu = function(params) {
    var eventParams = {
        environment_name: params.environment_name || "Ambiente n\xe3o definido",
        click_text: params.click_text || "Clique n\xe3o definido"
    };
    pushEventToDataLayer("app_ambiente_menu", eventParams);
};
/**
 * Evento disparado quando o usuário gera um cupom
 * @param params Parâmetros do evento
 */ var gtmCuponsGerarCupom = function(params) {
    pushEventToDataLayer("app_cupons_gerar_cupom", params);
};
/**
 * Evento disparado quando o usuário visualiza um cupom
 * @param params Parâmetros do evento
 */ var gtmCuponsVerCupom = function(params) {
    pushEventToDataLayer("app_cupons_ver_cupom", params);
};
/**
 * Converte um item da lista de produtos para o formato de item do GA4
 * @param item Item da lista de produtos
 * @param index Índice do item na lista
 * @param listName Nome da lista de produtos
 * @param listId ID da lista de produtos
 * @returns Item formatado para o GA4
 */ var formatItemToGA4 = function(item, index, listName, listId) {
    return {
        item_id: item.itemListaProdutoId || item.id || "produto_".concat(index),
        item_name: item.itemListaProdutoNome || item.nome || "Produto sem nome",
        coupon: item.itemListaProdutoCupom || undefined,
        currency: "BRL",
        discount: item.itemListaProdutoDesconto || 0,
        index: index,
        item_brand: item.itemListaProdutoLoja || undefined,
        item_category: item.categoriaNome || item.categoria || "Categoria n\xe3o definida",
        item_list_id: listId,
        item_list_name: listName,
        price: Number(item.itemListaProdutoPreco) || 0,
        quantity: item.itemListaProdutoQuantidade || 1
    };
};
/**
 * Converte uma lista de categorias em um array de itens no formato GA4
 * @param categorias Lista de categorias com itens
 * @param listName Nome da lista de produtos
 * @param listId ID da lista de produtos
 * @returns Array de itens formatados para o GA4
 */ var formatCategoriesToItems = function(categorias, listName, listId) {
    var items = [];
    var globalIndex = 0;
    var isCategoriaFormat = categorias.length > 0 && "itens" in categorias[0];
    if (isCategoriaFormat) {
        categorias.forEach(function(categoria) {
            if (categoria && categoria.itens && Array.isArray(categoria.itens)) {
                categoria.itens.forEach(function(item, index) {
                    var itemEnriquecido = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, item), {
                        categoriaNome: categoria.nome
                    });
                    items.push(formatItemToGA4(itemEnriquecido, globalIndex, listName, listId));
                    globalIndex++;
                });
            }
        });
    } else {
        categorias.forEach(function(item, index) {
            items.push(formatItemToGA4(item, index, listName, listId));
        });
    }
    return items;
};
/**
 * Dispara o evento view_item_list quando o usuário visualiza uma lista de produtos
 * @param items Array de itens no formato GA4
 * @param listName Nome da lista de produtos
 * @param listId ID da lista de produtos
 */ var gtmViewItemList = function(items, listName, listId) {
    var ref, ref1;
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
        ecommerce: null
    });
    (ref1 = window.dataLayer) === null || ref1 === void 0 ? void 0 : ref1.push({
        event: "view_item_list",
        ecommerce: {
            item_list_id: listId,
            item_list_name: listName,
            items: items
        }
    });
};
/**
 * Dispara o evento select_item quando o usuário clica em um produto
 * @param item Item no formato GA4
 * @param listName Nome da lista de produtos
 * @param listId ID da lista de produtos
 */ var gtmSelectItem = function(item, listName, listId) {
    var ref, ref1;
    (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push({
        ecommerce: null
    });
    (ref1 = window.dataLayer) === null || ref1 === void 0 ? void 0 : ref1.push({
        event: "select_item",
        ecommerce: {
            item_list_id: listId,
            item_list_name: listName,
            items: [
                item
            ]
        }
    });
};
/**
 * Evento disparado quando o usuário abre um story
 * @param params Parâmetros do evento de story
 */ var gtmStoriesOpen = function(params) {
    pushEventToDataLayer("open_story", params);
};
/**
 * Evento disparado quando o usuário visualiza um story
 * @param params Parâmetros do evento de story
 */ var gtmStoriesView = function(params) {
    pushEventToDataLayer("view_story", params);
};
/**
 * Evento disparado quando o usuário clica no CTA de um story
 * @param params Parâmetros do evento de CTA de story
 */ var gtmStoriesSelectCTA = function(params) {
    pushEventToDataLayer("select_cta_story", params);
};


/***/ }),

/***/ 48081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ formatarHoraLocal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80969);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);


function formatarHoraLocal(value) {
    if (value) {
        return moment__WEBPACK_IMPORTED_MODULE_0___default().utc(String(value), "HH:mm").local().format("HH:mm");
    }
    return "";
}
// Regra canônica do telefone BR: com mais de 11 dígitos começando com 55, o
// DDI já está lá e sai para exibir. Com 10 ou 11 dígitos o número é nacional
// e nada é removido (55 também é o DDD de Santa Maria/RS).
function removerDDIBrasil(apenasNumeros) {
    return apenasNumeros.length > 11 && apenasNumeros.startsWith("55") ? apenasNumeros.slice(2) : apenasNumeros;
}
// (DD) NNNNN-NNNN para celular, (DD) NNNN-NNNN para fixo. Outros tamanhos
// (digitação em andamento, número estrangeiro) voltam só com os dígitos.
function mascararTelefone(apenasNumeros) {
    if (apenasNumeros.length === 11) {
        return apenasNumeros.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    }
    if (apenasNumeros.length === 10) {
        return apenasNumeros.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
    return apenasNumeros;
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    // getConsultoriaStatusStyle(idStatus) {
    //   if (!idStatus) {
    //     return
    //   }
    //   switch (idStatus) {
    //     case config.CONSULTORIA_AGENDADA:
    //       return { backgroundColor: 'rgb(182, 124, 191)' }
    //     case config.CONSULTORIA_DESISTIU_ATEND:
    //       return { backgroundColor: 'rgb(226, 87, 87)' }
    //     case config.CONSULTORIA_ATEND_PAUSADO:
    //       return { backgroundColor: 'rgb(220, 195, 121)' }
    //     case config.CONSULTORIA_AGUARD_REAGEND:
    //       return { backgroundColor: 'rgb(23, 162, 184)' }
    //     case config.CONSULTORIA_ATEND_FINALIZADO:
    //       return { backgroundColor: 'rgb(113, 187, 130)' }
    //     case config.CONSULTORIA_ATEND_INICIADO:
    //       return { backgroundColor: 'rgb(3, 95, 199)' }
    //     case config.CONSULTORIA_AGUARD_AGEND:
    //       return { backgroundColor: 'rgb(124, 182, 255)' }
    //     case config.CONSULTORIA_AGUARD_PLANTAO:
    //       return { backgroundColor: 'rgb(255, 148, 0)' }
    //     case config.CONSULTORIA_CLIENTE_INATIVO:
    //       return { backgroundColor: 'rgb(255, 50, 70)' }
    //     case config.CONSULTORIA_MATERIAL_CONFERIDO:
    //       return { backgroundColor: 'rgb(171, 88, 88)' }
    //     case config.CONSULTORIA_MATERIAL_RECEBIDO:
    //       return { backgroundColor: 'rgb(190, 126, 126)' }
    //     case config.CONSULTORIA_MATERIAL_CONFERIDO_MAIS:
    //       return {
    //         backgroundColor: '#ffab2f',
    //         color: '#622fbd'
    //       }
    //     case config.CONSULTORIA_MATERIAL_REJEITADO:
    //       return { backgroundColor: 'rgb(220, 126, 126)' }
    //   }
    // },
    // obterPrimeirosCaracteres(texto, qtdCaracteres) {
    //   if (!texto) return ''
    //   if (texto.length > qtdCaracteres) {
    //     return `${texto.slice(0, qtdCaracteres)}...`
    //   }
    //   return texto
    // },
    formatarMoedaInput: function formatarMoedaInput(value) {
        var moeda = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "BRL";
        if (!value && value !== 0) return "";
        // Garantir que o valor seja uma string
        var stringValue = value.toString();
        // Remover qualquer caractere que não seja dígito
        stringValue = stringValue.replace(/\D/g, "");
        // Converter a string em um número
        var numberValue = parseFloat(stringValue);
        // Ajustar o valor para formatar como moeda
        var formattedValue = numberValue / 100;
        if (moeda === "EUR") {
            return formattedValue.toLocaleString("pt-PT", {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "EUR"
            });
        } else {
            return formattedValue.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                style: "currency",
                currency: "BRL"
            });
        }
    },
    formatarMoeda: function formatarMoeda(value, moeda) {
        if (value || value === 0) {
            if (moeda == "EUR") {
                return value.toLocaleString("pt-PT", {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "EUR"
                });
            } else {
                return value.toLocaleString("pt-BR", {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL"
                });
            }
        }
    },
    removerFormatacaoPreco: function removerFormatacaoPreco(precoFormatado) {
        if (!precoFormatado) return 0;
        // Remover o símbolo de moeda, espaços e pontos de milhar
        var precoSemFormato = precoFormatado.replace(/[^\d,]/g, "");
        // Substituir a vírgula por um ponto (para lidar com casas decimais no formato BR)
        precoSemFormato = precoSemFormato.replace(",", ".");
        // Converter a string em número
        var precoNumerico = parseFloat(precoSemFormato);
        // Retornar o número
        return isNaN(precoNumerico) ? 0 : precoNumerico;
    },
    obterPrimeiroNome: function obterPrimeiroNome(nomeCompleto) {
        if (!nomeCompleto) {
            return "";
        }
        var nomePosicao = nomeCompleto.split(" ")[0];
        if (!nomePosicao) {
            return "";
        }
        var primeiraMaiuscula = nomePosicao[0].toUpperCase() + nomePosicao.substr(1).toLowerCase();
        return primeiraMaiuscula;
    },
    // obterPrimeiroESegundoNome(nomeCompleto) {
    //   const primeiroNome = obterNomePorPosicao(nomeCompleto, 0)
    //   const segundoNome = obterNomePorPosicao(nomeCompleto, 1)
    //   return `${primeiroNome} ${segundoNome}`
    // },
    // obterNomePorPosicao(nomeCompleto: string, posicao: number) {
    //   if (!nomeCompleto) {
    //     return ''
    //   }
    //   const nomePosicao = nomeCompleto.split(' ')[posicao]
    //   if (!nomePosicao) {
    //     return ''
    //   }
    //   const primeiraMaiuscula =
    //     nomePosicao[0].toUpperCase() + nomePosicao.substr(1).toLowerCase()
    //   return primeiraMaiuscula
    // },
    // arrayInsertAtIndex(array, idx, value) {
    //   return [].concat(array.slice(0, idx), value, array.slice(idx))
    // },
    // phoneMask(value: string) {
    //   if (!value) return ''
    //   try {
    //     if (value.startsWith('+')) {
    //       const phoneNumber = parsePhoneNumberFromString(value)
    //       if (phoneNumber && isValidPhoneNumber(value)) {
    //         return phoneNumber.formatInternational()
    //       }
    //       return value
    //     }
    //     const apenasNumeros = value.replace(/\D/g, '')
    //     if (
    //       apenasNumeros.length > 10 &&
    //       (apenasNumeros.startsWith('1') ||
    //         apenasNumeros.startsWith('61') ||
    //         apenasNumeros.startsWith('351') ||
    //         apenasNumeros.startsWith('34') ||
    //         apenasNumeros.startsWith('33'))
    //     ) {
    //       try {
    //         const numeroComPlus = `+${apenasNumeros}`
    //         const phoneNumber = parsePhoneNumberFromString(numeroComPlus)
    //         if (phoneNumber && isValidPhoneNumber(numeroComPlus)) {
    //           return phoneNumber.formatInternational()
    //         }
    //         return numeroComPlus
    //       } catch {
    //         return `+${apenasNumeros}`
    //       }
    //     }
    //     if (apenasNumeros.length === 10 || apenasNumeros.length === 11) {
    //       try {
    //         const numeroComPlus = `+55${apenasNumeros}`
    //         const phoneNumber = parsePhoneNumberFromString(numeroComPlus)
    //         if (phoneNumber && isValidPhoneNumber(numeroComPlus)) {
    //           return phoneNumber.format('NATIONAL')
    //         }
    //       } catch {
    //         console.error('Erro ao formatar número de telefone')
    //       }
    //       return apenasNumeros
    //         .replace(/(\d{2})(\d)/, '($1) $2')
    //         .replace(/(\d)(\d{4})$/, '$1-$2')
    //     }
    //     return apenasNumeros.length > 0 ? `+${apenasNumeros}` : value
    //   } catch {
    //     return value
    //   }
    // },
    phoneMask: function phoneMask(value) {
        if (!value) return "";
        return mascararTelefone(removerDDIBrasil(value.replace(/\D/g, "")));
    },
    // Máscara do campo de telefone BR: mesma regra do phoneMask, mas nunca passa
    // de 11 dígitos (DDD + número). Quem cola "+55 11 98318-8812" vê
    // "(11) 98318-8812".
    telefoneBrMask: function telefoneBrMask(value) {
        if (!value) return "";
        return mascararTelefone(removerDDIBrasil(value.replace(/\D/g, "")).slice(0, 11));
    },
    // Telefone BR para gravar: só dígitos, com o 55 na frente.
    // "(21) 96831-0990" vira "5521968310990". Se já vier com o DDI (12 ou 13
    // dígitos começando com 55), fica como está.
    telefoneBrParaEnvio: function telefoneBrParaEnvio(value) {
        if (!value) return "";
        var apenasNumeros = value.replace(/\D/g, "");
        if (apenasNumeros.length === 10 || apenasNumeros.length === 11) {
            return "55".concat(apenasNumeros);
        }
        return apenasNumeros;
    },
    dateNascMask: function dateNascMask(value) {
        return value.replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{2})(\d)/, "$1/$2") //Coloca parênteses em volta dos dois primeiros dígitos
        .replace(/(\d{2})(\d)/, "$1/$2") //Coloca hífen entre o quarto e o quinto dígito
        ;
    },
    cepMask: function cepMask(value) {
        if (!value) return "";
        if (value) {
            return value.replace(/\D/g, "") //Remove tudo o que não é dígito
            .replace(/^(\d{5})(\d)/, "$1-$2") //Coloca traço entre o quinto e o sexto dígitos
            ;
        }
    },
    cpfMask: function cpfMask(value) {
        if (!value) return "";
        return value.replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
        .replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})/, "$1-$2").replace(/(-\d{2})\d+?$/, "$1") // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
        ;
    },
    // Máscara de CNPJ. Aceita letras nas 12 primeiras posições porque o CNPJ
    // é alfanumérico a partir de julho/2026 (IN RFB 2.229/2024).
    cnpjMask: function cnpjMask(value) {
        if (!value) return "";
        var limpo = value.replace(/[^0-9A-Za-z]/g, "").toUpperCase().slice(0, 14);
        return limpo.replace(/^([0-9A-Z]{2})([0-9A-Z])/, "$1.$2").replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, "$1.$2.$3").replace(/\.([0-9A-Z]{3})([0-9A-Z])/, ".$1/$2").replace(/\/([0-9A-Z]{4})([0-9A-Z])/, "/$1-$2");
    },
    documentoMask: function documentoMask(value) {
        if (!value) return "";
        var limpo = value.replace(/[^0-9A-Za-z]/g, "");
        if (/^\d{0,11}$/.test(limpo)) {
            return this.cpfMask(value);
        }
        return this.cnpjMask(value);
    },
    revertMask: function revertMask(value) {
        return value.replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
        ;
    },
    // Versão para documento (CPF/CNPJ): preserva letras porque o CNPJ é
    // alfanumérico nas 12 primeiras posições a partir de julho/2026.
    revertDocumentoMask: function revertDocumentoMask(value) {
        return value.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
    },
    formatarDataLocal: function formatarDataLocal(value) {
        if (value) {
            return moment__WEBPACK_IMPORTED_MODULE_0___default().utc(String(value)).local().format("DD/MM/YYYY");
        }
        return "";
    },
    formatarDataHoraLocal: function formatarDataHoraLocal(value) {
        if (value) {
            return moment__WEBPACK_IMPORTED_MODULE_0___default().utc(String(value)).local().format("DD/MM/YYYY HH:mm");
        }
        return "";
    },
    converterDataParaISO: function converterDataParaISO(dataString) {
        // Dividir a string da data no formato DD/MM/YYYY
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dataString.split("/").map(Number), 3), dia = ref[0], mes = ref[1], ano = ref[2];
        // Criar um objeto Date usando os valores extraídos e a hora atual
        var data = new Date(ano, mes - 1, dia);
        // Obter a hora atual
        var agora = new Date();
        // Atualizar a data com a hora atual
        data.setHours(agora.getHours(), agora.getMinutes(), agora.getSeconds(), agora.getMilliseconds());
        // Retornar a data no formato ISO 8601
        return data.toISOString();
    },
    // formatarHoraLocal
    // obterDiaSemana(value) {
    //   if (value) {
    //     return moment.utc(String(value)).local().format('dddd')
    //   }
    //   return ''
    // },
    // groupBy(arrayOfObject, key) {
    //   return arrayOfObject.reduce(function (rv, x) {
    //     ;(rv[x[key]] = rv[x[key]] || []).push(x)
    //     return rv
    //   }, {})
    // },
    // obterExtensaoArquivo(nomeArquivo) {
    //   if (!nomeArquivo) {
    //     return
    //   }
    //   const partesNomeArquivo = nomeArquivo.split('.')
    //   const extensaoArquivo =
    //     '.' + partesNomeArquivo[partesNomeArquivo.length - 1]
    //   return extensaoArquivo
    // },
    // parseNomeCompleto(nomeCompleto) {
    //   let primeiroNome = ''
    //   let restante = ''
    //   if (nomeCompleto) {
    //     const espacoIdx = nomeCompleto.indexOf(' ')
    //     if (espacoIdx >= 0) {
    //       primeiroNome = nomeCompleto.substr(0, espacoIdx)
    //       restante = nomeCompleto.substr(espacoIdx + 1)
    //     } else {
    //       primeiroNome = nomeCompleto
    //     }
    //   }
    //   return {
    //     primeiroNome: primeiroNome,
    //     restante: restante
    //   }
    // },
    // getOptions(itensObj) {
    //   if (!itensObj) {
    //     return []
    //   }
    //   const options = []
    //   for (const key in itensObj) {
    //     options.push({ text: itensObj[key], value: key })
    //   }
    //   return options
    // },
    // getUrlParameter(name) {
    //   name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
    //   const regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
    //   const results = regex.exec(location.search || location.hash)
    //   return results === null
    //     ? ''
    //     : decodeURIComponent(results[1].replace(/\+/g, ' '))
    // },
    // obterDescricaoAmbiente(ambienteValue) {
    //   const item = config.LISTA_AMBIENTES.find((i) => i.value == ambienteValue)
    //   return item?.text
    // },
    // obterDescricaoFuncaoArquiteto(idFuncao) {
    //   const item = config.FUNCOES_ARQUITETO.find((i) => i.id == idFuncao)
    //   return item?.descricao
    // },
    // obterCorFuncaoArquiteto(idFuncao) {
    //   const item = config.FUNCOES_ARQUITETO.find((i) => i.id == idFuncao)
    //   return item?.cor
    // }
    documentoValidator: function documentoValidator(valor) {
        if (!valor) return false;
        // Mantém letras: o CNPJ é alfanumérico nas 12 primeiras posições
        // a partir de julho/2026 (IN RFB 2.229/2024).
        var documento = valor.replace(/[^0-9A-Za-z]/g, "").toUpperCase();
        if (/^\d{11}$/.test(documento)) {
            return this.cpfValidator(documento);
        } else if (/^[0-9A-Z]{12}\d{2}$/.test(documento)) {
            return this.cnpjValidator(documento);
        }
        return false;
    },
    cpfValidator: function cpfValidator(cpfComOuSemMascara) {
        if (!cpfComOuSemMascara) {
            return false;
        }
        //Extraindo somente os números
        var cpf = cpfComOuSemMascara.replace(/[^0-9]/g, "");
        var numeros, digitos, soma, i, resultado, digitos_iguais;
        digitos_iguais = 1;
        if (cpf.length < 11) return false;
        for(i = 0; i < cpf.length - 1; i++)if (cpf.charAt(i) != cpf.charAt(i + 1)) {
            digitos_iguais = 0;
            break;
        }
        if (!digitos_iguais) {
            numeros = cpf.substring(0, 9);
            digitos = cpf.substring(9);
            soma = 0;
            for(i = 10; i > 1; i--)soma += numeros.charAt(10 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) return false;
            numeros = cpf.substring(0, 10);
            soma = 0;
            for(i = 11; i > 1; i--)soma += numeros.charAt(11 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) return false;
            return true;
        } else return false;
    },
    // Pesos do Mod-11 do CNPJ. O slice ajusta para a base de 12 ou 13 posições.
    PESOS_CNPJ: [
        6,
        5,
        4,
        3,
        2,
        9,
        8,
        7,
        6,
        5,
        4,
        3,
        2
    ],
    // Calcula um dígito verificador do CNPJ.
    // O valor de cada caractere é o código ASCII menos 48, então '0'-'9' valem
    // 0-9 e 'A'-'Z' valem 17-42 (regra do CNPJ alfanumérico, IN RFB 2.229/2024).
    calcularDVCNPJ: function calcularDVCNPJ(base) {
        var pesos = this.PESOS_CNPJ.slice(this.PESOS_CNPJ.length - base.length);
        var soma = 0;
        for(var i = 0; i < base.length; i++){
            soma += (base.charCodeAt(i) - 48) * pesos[i];
        }
        var resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    },
    // Valida CNPJ numérico ou alfanumérico: as 12 primeiras posições aceitam
    // [0-9A-Z] e os 2 dígitos verificadores continuam numéricos.
    cnpjValidator: function cnpjValidator(cnpj) {
        var limpo = (cnpj || "").replace(/[^0-9A-Za-z]/g, "").toUpperCase();
        if (!/^[0-9A-Z]{12}\d{2}$/.test(limpo)) return false;
        if (/^(.)\1{13}$/.test(limpo)) return false // Verifica sequências repetidas
        ;
        return this.calcularDVCNPJ(limpo.substring(0, 12)) === Number(limpo.charAt(12)) && this.calcularDVCNPJ(limpo.substring(0, 13)) === Number(limpo.charAt(13));
    },
    normalizeText: function normalizeText(text) {
        return text.toLowerCase() // Converter para letras minúsculas
        .normalize("NFD") // Normalizar acentos
        .replace(/[\u0300-\u036f]/g, "") // Remover acentos
        .replace(/[^a-z0-9]/g, " ") // Remover caracteres não alfanuméricos
        ;
    }
});


/***/ })

}]);